import type { ReportType } from '@parkchirp/reporting';
import type { ComponentType } from 'react';
import { InvoiceMonthlyDetailReportForm } from './InvoiceMonthlyDetailReportForm';
import { MonthlyParkingPaymentForm } from './MonthlyParkingPaymentForm';
import { PaymentSummaryReportForm } from './PaymentSummaryReportForm';
import { TransactionReportForm } from './TransactionReportForm';
import type { ReportFormProps } from './types';

export const reportComponents = {
	paymentSummary: PaymentSummaryReportForm,
	transaction: TransactionReportForm,
	invoiceMonthlyDetail: InvoiceMonthlyDetailReportForm,
	monthlyParkingPayment: MonthlyParkingPaymentForm,
} satisfies Record<ReportType, ComponentType<ReportFormProps>>;
